
import {map, take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { AuthService } from './auth.service';
import { RolesAccessData } from './aclData';

import { Observable } from 'rxjs';



@Injectable()
export class AuthGuard implements CanActivate {
    private previousRoute: String;

    constructor(
        private authService: AuthService,
        private router: Router,
        private roles: RolesAccessData
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
        this.previousRoute = this.router.url;
        return this.authService.isLoggedIn.pipe(       // {1}
            take(1),                               // {2}
            map((isLoggedIn: boolean) => {        // {3}
                if (!isLoggedIn) {
                    this.router.navigate(['/login']);  // {4}
                    // window.location.href = '/web';
                    return false;
                } else {
                    let moduleRoutes = this.authService.user.clientAcl.moduleRoutes;
                    for (let modulee in moduleRoutes) {
                        if (moduleRoutes[modulee] === null) {
                            continue;
                        }
                        for (let i = 0; i < moduleRoutes[modulee].length; i++) {
                            if (state.url.indexOf(moduleRoutes[modulee][i]) === 0) {
                                return true;
                            }
                        }
                    }
                    this.router.navigate([this.previousRoute]);
                    // please don't remove this comment
                    // return this.roles.staticData[user.role].associate[state.url].value;
                    console.log('here');
                    return false;
                }
            }),);
    }
}
